import { formSchema } from '../config/staffForm.schema';
import React from "react";
import { PartyField, PartyFormSection } from "../../../shared/components/PartyFormFields";
import CustomFieldsSection from "../../clients/components/ClientCustomFieldsSection";
import {
  archiveStaffCustomField,
  createStaffCustomField,
  listStaffCustomFields,
} from "../services/staff.service";

const customFieldsApi = {
  list: listStaffCustomFields,
  create: createStaffCustomField,
  archive: archiveStaffCustomField,
};

/** One field definition for both creation and editing of external team members. */
export default function StaffFormFields({ value, onFieldChange, splitName = false, disabled = false }) {
  const field = (name, props = {}) => <PartyField id={`staff-${name}`} label={formSchema.field(name).label}
    value={Array.isArray(value[name]) ? value[name].join(', ') : value[name]}
    onChange={next => onFieldChange(name, next)} disabled={disabled} {...props} />;
  return (
    <>
      {splitName ? <div className="party-form__row">
        {field('firstName', { required: true, placeholder: 'es: Alessandro', autoComplete: 'given-name' })}
        {field('lastName', { required: true, placeholder: 'es: Bianchi', autoComplete: 'family-name' })}
      </div> : field('name', { required: true })}
      {field('role', { required: true, placeholder: 'es: Consulente Cloud Senior, Sviluppatore Mobile...' })}
      <div className="party-form__field">
        {field('skills', { multiline: true, rows: 4, placeholder: 'es: React, Node.js, AWS, UX/UI Design, Project Management...' })}
        <p className="party-form__help">Separa le competenze con una virgola.</p>
      </div>
      <PartyFormSection title="Recapiti di contatto">
        <div className="party-form__row">
          {field('email', { type: 'email', required: splitName, placeholder: 'es: alessandro.bianchi@esempio.it', autoComplete: 'email' })}
          {field('phone', { type: 'tel', placeholder: 'es: +39 347 1234567', autoComplete: 'tel' })}
        </div>
      </PartyFormSection>
      <CustomFieldsSection
        formKey="staff.member.create"
        values={value.customFields || {}}
        onChange={(fields) => onFieldChange("customFields", fields)}
        api={customFieldsApi}
      />
    </>
  );
}
